<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="事务类别管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
           
         <el-form-item label="事务标题">
            <el-input v-model="params.AffairsTitle" placeholder="请输入事务标题" clearable />
          </el-form-item>
                             
           
        </template>
        <template slot="table">
          <el-table-column prop="AffairsTitle" label="事务标题"  />
          <el-table-column prop="HandleCycle" label="办理周期"   />
          <el-table-column prop="HandleMoney" label="办理费用" />
                          
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
        AffairsTitle: "",
        
        }, 
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{AffairsTitle:"测试办理事项一",HandleCycle:"20-25个工作日",HandleMoney:"3000-4000元"},{AffairsTitle:"测试办理事项二",HandleCycle:"15-20个工作日",HandleMoney:"2000-2500元"}]});
      })
    },
     
    },
  };
  </script>